import { render, staticRenderFns } from "./con-under-construction.layout.vue?vue&type=template&id=44316fd0&scoped=true&"
import script from "./con-under-construction.layout.vue?vue&type=script&lang=ts&"
export * from "./con-under-construction.layout.vue?vue&type=script&lang=ts&"
import style0 from "./con-under-construction.layout.vue?vue&type=style&index=0&id=44316fd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44316fd0",
  null
  
)

export default component.exports